export default "__VITE_ASSET__CyYVyE5E__"